import React, { useState, useEffect } from 'react';
import firebase from 'firebase';
import { 
  BrowserRouter,
  Switch,
  Route,
  // Redirect
} from 'react-router-dom';
import {
  createMuiTheme,
  ThemeProvider,
  CircularProgress
} from '@material-ui/core';

import withTheme, { GlobalStyle, ThemeProps } from './Theme';

import Layout from './organisms/Layout';
import Pedalboard from './organisms/Pedalboard';
import Login from './organisms/Admin/Login';
import Home from './organisms/Admin/Home';
import RegisterBoard from './organisms/Admin/Board/register';
import RemoveBoard from './organisms/Admin/Board/remove';

import './utils/firebase';

const MaterialTheme = (theme: ThemeProps) => createMuiTheme({
  palette: {
    type: 'dark',
    primary: {
      main: theme.colors.primary
    },
    secondary: {
      main: theme.colors.secondary
    }
  }
});

const App: React.FC = ({ theme }: any) => {
  const [user, setUser] = useState();
  const [connected, setConnection] = useState(false);
  useEffect(() => {
    firebase.auth().onAuthStateChanged((fbUser: any) => {
      setUser(fbUser);
      if (!connected) {
        setTimeout(() => setConnection(true), 500);
      }
    })
    // eslint-disable-next-line
  }, []);
  return <ThemeProvider theme={MaterialTheme(theme)}>
    <GlobalStyle />
    <BrowserRouter>
      <Switch>
        {
          connected
            ? <>
              {
                user
                ? <Layout dashboard>
                    <Route path="/" component={Pedalboard} exact />
                    <Route path="/admin" component={Home} exact />
                    <Route path="/admin/board/register" component={RegisterBoard} exact />
                    <Route path="/admin/board/remove" component={RemoveBoard} exact />
                  </Layout>
                  : <>
                    <Route path="/" component={Pedalboard} exact />
                    <Route path="/admin" component={Login} />
                    {/* <Route render={() => <Redirect to="/" />} /> */}
                  </>
              }
            </>
            : <>
              <Route component={() => <CircularProgress />} />
            </>
        }
      </Switch>
    </BrowserRouter>
  </ThemeProvider>
}

export default withTheme(App);
